(() => {
  const toggles = [...document.querySelectorAll('[data-hw-tap-toggle]')];
  const config = document.querySelector('[data-hw-sound-sources]');
  if (!toggles.length || !config || typeof window.Audio !== 'function') return;
  const sliders = [...document.querySelectorAll('[data-hw-tap-volume]')];
  const deviceVolume = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  let enabled = true, armed = false, volume = 60, sequence = 0, last = -Infinity, active = null;
  try {
    enabled = sessionStorage.getItem('jessica-halloween-taps') !== 'off';
    const stored = Number(sessionStorage.getItem('jessica-halloween-volume') ?? 60);
    if (Number.isFinite(stored)) volume = Math.max(0, Math.min(100, stored));
  } catch {}
  const sounds = new Map();
  const stop = () => {
    sounds.forEach(audio => { audio.pause(); try { audio.currentTime = 0; } catch {} });
    active = null;
  };
  const update = () => {
    toggles.forEach(button => {
      button.setAttribute('aria-pressed', String(enabled && armed));
      button.querySelector('[data-hw-tap-label]').textContent = enabled && armed ? button.dataset.on : button.dataset.off;
    });
    sliders.forEach(slider => {
      slider.value = String(volume);
      // iOS media volume belongs to the device, not the website slider.
      slider.closest('label').hidden = !enabled || deviceVolume;
    });
  };
  const save = () => {
    try {
      sessionStorage.setItem('jessica-halloween-taps', enabled ? 'on' : 'off');
      sessionStorage.setItem('jessica-halloween-volume', String(volume));
    } catch {}
  };
  ['creak', 'laugh'].forEach(kind => {
    if (!config.dataset[kind]) return;
    const audio = new window.Audio();
    audio.preload = 'auto';
    audio.loop = false;
    audio.setAttribute('playsinline', '');
    audio.setAttribute('webkit-playsinline', '');
    audio.setAttribute('data-hw-sample', kind);
    audio.src = config.dataset[kind];
    if (!deviceVolume) audio.volume = volume / 100;
    config.append(audio);
    audio.addEventListener('ended', () => { if (active === audio) active = null; });
    sounds.set(kind, audio);
  });
  // Keep play() synchronous inside the trusted click. No fetch/decode/await
  // before it: Safari can reject playback once the gesture has expired.
  const play = (kind, force = false) => {
    if (!enabled || document.hidden || (!deviceVolume && volume === 0)) return;
    const audio = sounds.get(kind); if (!audio) return;
    const time = performance.now();
    if (!force && time - last < 220) return;
    last = time;
    if (active && active !== audio) active.pause();
    try {
      audio.currentTime = 0;
      active = audio;
      const playback = audio.play();
      armed = true; update();
      if (playback && typeof playback.catch === 'function') playback.catch(error => {
        // A superseded clip is normal during quick taps. A gesture block
        // instead returns the control to ATTIVA SUONO for an explicit retry.
        if (active !== audio || error?.name === 'AbortError') return;
        active = null;
        if (error?.name === 'NotAllowedError') { enabled = false; armed = false; save(); update(); }
        else if (error?.name === 'NotSupportedError') {
          enabled = false; stop(); update();
          toggles.forEach(button => { button.querySelector('[data-hw-tap-label]').textContent = button.dataset.error; });
        }
      });
    } catch { active = null; }
  };
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const element = event.target instanceof Element ? event.target.closest('button,a[href],summary,[role="button"],select') : null;
    if (!element || element.closest('[data-hw-tap-toggle],.hw-sound-volume') || element.matches(':disabled,[aria-disabled="true"]')) return;
    play(['creak', 'creak', 'laugh', 'creak'][sequence++ % 4]);
  }, { capture: true, passive: true });
  toggles.forEach(button => button.addEventListener('click', event => {
    if (!event.isTrusted) return;
    enabled = !(enabled && armed);
    if (!enabled) armed = false;
    if (enabled && volume === 0) {
      volume = 60;
      sounds.forEach(audio => { if (!deviceVolume) audio.volume = volume / 100; });
    }
    save(); update();
    if (enabled) play('laugh', true); else stop();
  }));
  sliders.forEach(slider => slider.addEventListener('input', () => {
    volume = Math.max(0, Math.min(100, Number(slider.value)));
    sounds.forEach(audio => { if (!deviceVolume) audio.volume = volume / 100; });
    sliders.forEach(other => { other.value = String(volume); });
    save();
  }));
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    try {
      enabled = sessionStorage.getItem('jessica-halloween-taps') !== 'off';
      const stored = Number(sessionStorage.getItem('jessica-halloween-volume') ?? 60);
      if (Number.isFinite(stored)) volume = Math.max(0, Math.min(100, stored));
    } catch {}
    sounds.forEach(audio => { if (!deviceVolume) audio.volume = volume / 100; });
    update();
  });
  const heroControl = document.querySelector('.hero [data-hw-tap-toggle]');
  const dock = document.querySelector('.hw-tap-dock');
  if (heroControl && dock && 'IntersectionObserver' in window) new IntersectionObserver(entries => { dock.hidden = entries[0].isIntersecting; }).observe(heroControl);
  update();
})();